"use client";

import Image from "next/image";
import Link from "next/link";

import { Button } from "@/components/ui/button";
import { getImageUrl } from "@/shared/utils/image";

const services = [
  {
    image: "/convocation/convocation-image-11.jpg",
    href: "/convocation/booking",
    title: "Convocation",
    description: "Professional studio photography for graduation portraits and milestone moments.",
    cta: "Book Convocation",
  },
  {
    image: "/talent-collection-3/KDTX0129.jpg",
    href: "/raya/booking",
    title: "Raya",
    description: "Clean and polished photography for festive portraits, couples, and families.",
    cta: "Book Raya",
  },
] as const;

export const LandingServicesSection = () => {
  return (
    <section id="featured-sessions" className="px-6 py-16 lg:px-12 lg:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="max-w-2xl">
          <p className="text-[10px] uppercase tracking-[0.35em] text-stone-500">Professional Services</p>
          <h2 className="mt-4 font-serif text-4xl leading-tight tracking-tight text-stone-100 sm:text-5xl">
            Clear services. Direct booking.
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-7 text-stone-400 sm:text-base">
            Choose between Convocation and Raya.
          </p>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2">
          {services.map((service) => (
            <article
              key={service.href}
              className="group relative aspect-[4/4.7] overflow-hidden rounded-[2.5rem] border border-white/10 bg-stone-950 shadow-[0_24px_80px_rgba(0,0,0,0.3)]"
            >
              <Image
                src={getImageUrl(service.image)}
                alt={service.title}
                fill
                className="object-cover transition-transform duration-700 group-hover:scale-[1.06]"
                sizes="(max-width: 1024px) 100vw, 50vw"
              />
              <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(0,0,0,0.05)_0%,rgba(0,0,0,0.14)_34%,rgba(0,0,0,0.88)_100%)]" />
              <div className="absolute inset-x-5 top-5 flex justify-end">
                <span className="text-[10px] uppercase tracking-[0.3em] text-stone-200/70">
                  LQ Studio
                </span>
              </div>

              <div className="absolute inset-x-0 bottom-0 z-10 p-6">
                <h3 className="font-serif text-3xl text-white sm:text-[2rem]">{service.title}</h3>
                <p className="mt-3 max-w-sm text-sm leading-7 text-stone-300">{service.description}</p>

                <div className="mt-5 flex justify-end">
                  <Button
                    asChild
                    variant="outline"
                    className="h-12 rounded-full border-white/14 bg-white/6 px-6 text-xs uppercase tracking-[0.25em] text-white hover:bg-white/12 hover:text-white"
                  >
                    <Link href={service.href}>{service.cta}</Link>
                  </Button>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
